<style scoped>
    .vue-modal {
        display: block;
    }
</style>
<template>
    <div style="display:inline-block">
        <button
                class="btn btn-primary btn-sm"
                @click="showCompositionList()"
                :title="trans('show_composition_list')"><i class="fa fa-list"></i></button>
        <button
                class="btn btn-primary btn-sm"
                @click="downloadCompositionList()"
                :title="trans('download_composition_list')"><i class="fa fa-file-excel-o"></i>
        </button>
        <correos-print-controls
            v-show="showCorreos"
            :translations="translations"
        >
        </correos-print-controls>
      <ups-print-controls
          v-show="showUps"
          :translations="translations"
      >
      </ups-print-controls>
      <gls-print-controls
          v-show="showGls"
          :translations="translations"
      >
      </gls-print-controls>
    </div>

</template>

<script>
    import * as Functions from '../../Functions';

    export default {
        props: ['translations'],
        data: function () {
            return {
                checked: [],
                delivery_type_code: 'all'
            };
        },
        ready: function () {
            Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
        },
        mounted: function () {
        },
        computed : {
            showCorreos() {
                return this.delivery_type_code === 1; //'correos';
            },
            showUps() {
              return this.delivery_type_code === 2; //'ups';
            },
            showGls() {
              return this.delivery_type_code === 4; //'gls';
            }
        },
        methods: {
            trans(name, path = 'print_controls') {
                return Functions.trans(this.translations, name, path);
            },
            showCompositionList: function () {
                if (this.checkLength()) {
                    this.openWithPost('/shop/orders/print/composition_list/show', {ids: this.checked});
                }
            },
            downloadCompositionList: function () {
                if (this.checkLength()) {
                    this.openWithPost('/shop/orders/print/composition_list/download', {ids: this.checked});
                }
            },
            checkLength: function() {
                if (this.checked.length < 1) {
                    this.orderNotFound();
                    return false;
                }
                return true;
            },
            orderNotFound: function () {
                alert(this.trans('orders_not_selected', null));
            },
            openWithPost: function (url, data) {
                let form = document.createElement("form");
                form.action = url;
                form.method = 'POST';
                form.target = "_blank";

                for (let key in data) {
                    this.appendInputToForm(form, key, data[key]);
                }
                this.appendInputToForm(form, '_token', document.querySelector('#token').getAttribute('content'));

                form.style.display = 'none';
                document.body.appendChild(form);
                form.submit();
            },
            appendInputToForm: function (form, key, value) {
                let input = document.createElement("textarea");
                input.name = key;
                input.value = typeof value === "object" ? JSON.stringify(value) : value;
                form.appendChild(input);
            }
        },
        created: function () {
            this.$root.$on('update:checked', (val) => {
                this.checked = val
            });
          this.$root.$on('update:delivery-type-filter', (delivery_type_code) => {
            this.delivery_type_code = delivery_type_code;
          });
        }
    }
</script>
